import React, { createRef, useContext, useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  IconButton,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import ReplyIcon from '@material-ui/icons/Reply';
import SendIcon from '@material-ui/icons/Send';

import { urlConfig } from '../../../../config/urlConfig';
import {
  accessTokenRequest,
  sendRequest,
} from '../../../../services/global/global.service';
import { CommentContext } from '../../../../services/meeting-details/meeting-details-comment.context';

import { Reply } from './reply';

const useStyles = makeStyles((theme) => {
  return {
    avatar: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: 16,
    },
    cardHeader: {
      backgroundColor: '#f7f7f7',
    },
    comment: {
      margin: '1rem 0',
    },
    commentAvatar: {
      width: theme.spacing(7),
      height: theme.spacing(7),
    },
    commentText: {
      whiteSpace: 'pre-line',
    },
    wrapper: {
      width: 'max-content',
      margin: '24px 0',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  };
});

export const Comment = ({ comment, m_id }) => {
  const classes = useStyles();
  const { users, replies, addReply, isReplyLoading } =
    useContext(CommentContext);
  const [open, setOpen] = useState(false);
  const [reply, setReply] = useState('');
  const [user, setUser] = useState('');
  const inputRef = createRef();

  useEffect(() => {
    if (reply && inputRef && inputRef.current) {
      inputRef.current.dir = 'auto';
    }
  }, [reply]);

  //Get the user information of this comment
  const getUser = (users, comment) => {
    return (
      users &&
      users.length > 0 &&
      users.filter((user) => user.uid === comment.user_uuid)
    );
  };

  useEffect(() => {
    setUser(getUser(users, comment)[0]);
  }, [comment, users]);

  return (
    <>
      {comment && comment.level === 0 && (
        <Card className={classes.comment}>
          <CardHeader
            className={classes.cardHeader}
            avatar={
              <Avatar
                className={classes.commentAvatar}
                src={user && user.avatar}
              >
                {user && user.username && user.username[0].toUpperCase()}
              </Avatar>
            }
            action={
              <IconButton
                aria-label='settings'
                onClick={() => {
                  setOpen(!open);
                  setReply('');
                }}
              >
                <ReplyIcon />
              </IconButton>
            }
            title={
              <Typography variant='h6'>{user && user.username}</Typography>
            }
            subheader={
              comment.submit_date &&
              moment(comment.submit_date).format('MMMM. DD, YYYY, HH:mm A')
            }
          />

          <Divider />

          <CardContent dir='auto'>
            <Typography className={classes.commentText}>
              {comment.comment}
            </Typography>
          </CardContent>

          {open && (
            <Box display='flex' p={2}>
              <TextField
                inputRef={inputRef}
                label='Reply'
                value={reply}
                fullWidth
                onChange={(e) => {
                  setReply(e.target.value);
                }}
                multiline
              />
              <Box className={classes.wrapper}>
                <Button
                  size='small'
                  type='submit'
                  endIcon={<SendIcon />}
                  onClick={(e) =>
                    addReply(e, m_id, reply, comment, setReply, setOpen)
                  }
                  disabled={isReplyLoading}
                />
                {isReplyLoading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </Box>
            </Box>
          )}
        </Card>
      )}

      {replies &&
        replies.length > 0 &&
        replies.map(
          (reply, index) =>
            reply.parent_id === comment.parent_id && (
              <Reply reply={reply} key={index} />
            )
        )}
    </>
  );
};
